const TelefarmTheme = {
    images : {
        loginLogo: "/img/telefarm/telefarm-logo.png",
        whiteLogo: "/img/telefarm/telefarm-logo.png",
        favicon: "/img/telefarm/favicon.ico",
        leftMenuLogo: "/img/telefarm/telefarm-logo.png",
        headerLogo: "/img/telefarm/telefarm-logo.png",

        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image",
        qrcodeLogo: "/img/telefarm/telefarm-logo.png"
    },
    css: [
        "/themes/telefarm/telefarm.css"
    ],
    strings: {
        title: "Telefarm"
    }
}

export default TelefarmTheme;